import { isSolarSolutionsDevice } from "@/helpers/sensorTypes";

export const SOLAR_ACTIONS_SENSOR_TYPE = 640;

export function isSolarActionsDevice(device) {
  return isSolarSolutionsDevice(device);
}

export function hasSolarActionsDevice(devicesMap) {
  return Object.values(devicesMap || {}).some((device) =>
    isSolarActionsDevice(device)
  );
}
